import { getI18n } from "@/shared/i18n/i18n";
import { Total } from "@/shared/search/search.types.ts";

export const generateTotalText = (total: Total | undefined) => {
    if (!total) return;

    if (total.count === 0) return "0";

    let countString = total.count.toString();

    switch (total.countRelation) {
        case "gte":
            countString = `>${total.count}`;
            break;
        case "lte":
            countString = `<${total.count}`;
            break;
    }

    return countString;
};

export const generateSearchHitsText = (total: Total | undefined) => {
    const i18n = getI18n();
    const countString = generateTotalText(total);

    return i18n.global.t("shared.{count} Results", { count: countString });
};
